(function () {
  'use strict';

  var STRUCTURAL_SELECTOR = 'h1,h2,h3,h4,h5,h6,p,ul,ol,blockquote,figure,table,section,article';

  function isVisible(element) {
    if (!element) return false;
    var node = element;
    while (node && node.nodeType === 1) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
      node = node.parentElement;
    }
    return true;
  }

  function copyAttributes(from, to) {
    Array.prototype.forEach.call(from.attributes || [], function (attribute) {
      to.setAttribute(attribute.name, attribute.value);
    });
  }

  function replaceSimpleDivs(content) {
    Array.prototype.slice.call(content.children).forEach(function (child) {
      if (child.tagName !== 'DIV') return;
      if (child.className && String(child.className).indexOf('hw-') !== -1) return;
      if (child.querySelector(STRUCTURAL_SELECTOR)) return;
      if (!(child.textContent || '').trim()) return;

      var paragraph = document.createElement('p');
      copyAttributes(child, paragraph);
      while (child.firstChild) paragraph.appendChild(child.firstChild);
      child.replaceWith(paragraph);
    });
  }

  // Shopify can preserve pasted editor paragraphs as one simple DIV separated by
  // repeated BR elements. Turn only those double-break runs into semantic
  // paragraphs; single BR elements remain intentional line breaks.
  function splitBreakParagraphs(container) {
    var candidates = [container].concat(Array.prototype.slice.call(container.children));
    candidates.forEach(function (candidate) {
      if (candidate !== container && candidate.tagName !== 'DIV') return;
      if (candidate === container && Array.prototype.some.call(candidate.children, function (child) {
        return child.matches(STRUCTURAL_SELECTOR);
      })) return;
      if (candidate !== container && candidate.querySelector(STRUCTURAL_SELECTOR)) return;

      var nodes = Array.prototype.slice.call(candidate.childNodes);
      var hasDoubleBreak = nodes.some(function (node, index) {
        return node.nodeName === 'BR' && nodes[index + 1] && nodes[index + 1].nodeName === 'BR';
      });
      if (!hasDoubleBreak) return;

      var fragment = document.createDocumentFragment();
      var paragraph = document.createElement('p');
      var breakRun = 0;

      function finishParagraph() {
        if ((paragraph.textContent || '').trim() || paragraph.querySelector('img,a')) {
          fragment.appendChild(paragraph);
        }
        paragraph = document.createElement('p');
      }

      nodes.forEach(function (node) {
        if (node.nodeName === 'BR') {
          breakRun += 1;
          if (breakRun === 1) paragraph.appendChild(node.cloneNode());
          return;
        }
        if (breakRun >= 2) {
          if (paragraph.lastChild && paragraph.lastChild.nodeName === 'BR') paragraph.lastChild.remove();
          finishParagraph();
        }
        breakRun = 0;
        paragraph.appendChild(node.cloneNode(true));
      });
      finishParagraph();

      if (candidate === container) {
        container.replaceChildren(fragment);
      } else {
        candidate.replaceWith(fragment);
      }
    });
  }

  function normalizeBody(content) {
    if (!content) return;
    splitBreakParagraphs(content);
    replaceSimpleDivs(content);
  }

  function narrativeParagraphs(content) {
    return Array.prototype.slice.call(content.querySelectorAll('p')).filter(function (paragraph) {
      if (!isVisible(paragraph)) return false;
      if (paragraph.closest('.hw-editorial-component,.hw-article__block,blockquote,figure,li,table')) return false;
      return (paragraph.textContent || '').replace(/\s+/g, ' ').trim().length > 0;
    });
  }

  function calloutTargetIndex(position, paragraphCount) {
    if (!paragraphCount) return 0;
    if (position === 'after-body') return 0;

    var requested = parseInt(String(position || '').replace('after-', ''), 10);
    var target;

    if (position === 'auto' || Number.isNaN(requested)) {
      target = paragraphCount < 3 ? Math.ceil(paragraphCount / 2) : 3;
    } else {
      target = requested;
    }
    return Math.max(1, Math.min(target, paragraphCount));
  }

  function placeArticleCallout(root, content) {
    var callouts = Array.prototype.slice.call(root.querySelectorAll('[data-article-callout]'));
    var callout = callouts.shift();
    if (!callout || !content) return;

    // Section refreshes must never leave two copies of the shared callout.
    // Liquid emits one, and this guard removes any stale duplicate before moving it.
    callouts.forEach(function (duplicate) { duplicate.remove(); });

    var position = callout.dataset.calloutPosition || 'auto';
    if (position === 'after-body') return;

    var paragraphs = narrativeParagraphs(content);
    if (!paragraphs.length) return;

    var target = calloutTargetIndex(position, paragraphs.length);
    if (!target) return;
    paragraphs[target - 1].insertAdjacentElement('afterend', callout);
    callout.dataset.calloutPlaced = 'true';
  }

  function copyText(value) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        if (document.execCommand('copy')) resolve();
        else reject(new Error('Copy command was not accepted'));
      } catch (error) {
        reject(error);
      } finally {
        field.remove();
      }
    });
  }

  function initShareActions(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-copy-link]')).forEach(function (button) {
      if (button.dataset.copyReady === 'true') return;
      button.dataset.copyReady = 'true';
      button.addEventListener('click', function () {
        var label = button.querySelector('[data-copy-label]');
        var card = button.closest('.hw-article__sidebar-card--share');
        var status = card && card.querySelector('[data-copy-status]');
        var url = button.dataset.copyUrl || window.location.href;

        copyText(url).then(function () {
          if (label) label.textContent = 'Copied';
          if (status) status.textContent = 'Article link copied to clipboard.';
          window.setTimeout(function () {
            if (label) label.textContent = 'Copy link';
            if (status) status.textContent = '';
          }, 2400);
        }).catch(function () {
          if (status) status.textContent = 'Copy failed. Select the address from your browser.';
        });
      });
    });
  }

  function uniqueHeadingId(heading, usedIds) {
    if (heading.id && !usedIds[heading.id]) {
      usedIds[heading.id] = true;
      return heading.id;
    }

    var label = (heading.textContent || '').trim();
    var base = label
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 60) || 'section';
    var candidate = base;
    var suffix = 2;

    while (document.getElementById(candidate) || usedIds[candidate]) {
      candidate = base + '-' + suffix++;
    }
    heading.id = candidate;
    usedIds[candidate] = true;
    return candidate;
  }

  function buildToc(content, toc) {
    if (!content || !toc) return;
    var tocCard = toc.closest('.hw-article__sidebar-card');
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2,h3')).filter(function (heading) {
      if (!isVisible(heading)) return false;
      if (heading.closest('.hw-editorial-component,.hw-article__block')) return false;
      return (heading.textContent || '').trim().length > 0;
    });

    toc.replaceChildren();
    if (!headings.length) return;

    var usedIds = {};
    headings.forEach(function (heading) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      var id = uniqueHeadingId(heading, usedIds);

      if (heading.tagName === 'H3') item.className = 'hw-article__toc-item--nested';
      link.href = '#' + id;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', function () {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        window.requestAnimationFrame(function () {
          heading.focus({ preventScroll: true });
        });
      });
      item.appendChild(link);
      toc.appendChild(item);
    });

    if (!tocCard || !toc.children.length) return;
    tocCard.hidden = false;

    /*
     * Below 1024px the sidebar collapses into the article flow, where an expanded
     * list of every heading can push the opening paragraph off screen. Start it
     * collapsed so the reader reaches the article immediately — the summary keeps
     * the navigation available rather than hiding it. Desktop keeps the markup's
     * `open` state because CSS renders it as a static sidebar card there.
     * Only set on first build so a reader's own toggle is never overridden.
     */
    if (tocCard.dataset.hwTocInitialised !== 'true') {
      tocCard.dataset.hwTocInitialised = 'true';
      if (window.matchMedia('(max-width: 1024px)').matches) tocCard.open = false;
    }
  }

  function countWords(content) {
    var clone = content.cloneNode(true);
    var originals = Array.prototype.slice.call(content.querySelectorAll('*'));
    var copies = Array.prototype.slice.call(clone.querySelectorAll('*'));
    for (var index = originals.length - 1; index >= 0; index -= 1) {
      if (!isVisible(originals[index]) && copies[index] && copies[index].parentNode) {
        copies[index].remove();
      }
    }
    Array.prototype.slice.call(clone.querySelectorAll('[hidden],[aria-hidden="true"],script,style')).forEach(function (node) {
      node.remove();
    });
    Array.prototype.slice.call(clone.querySelectorAll('a')).forEach(function (link) {
      if (/^\s*(https?:\/\/|www\.)\S+\s*$/i.test(link.textContent || '')) link.remove();
    });
    var matches = (clone.textContent || '').match(/[\p{L}\p{N}]+(?:[’'.-][\p{L}\p{N}]+)*/gu);
    return matches ? matches.length : 0;
  }

  function estimateReadingTime(root, content) {
    var target = root.querySelector('[data-reading-time]');
    if (!target || !content) return;

    var words = countWords(content);
    var figures = Array.prototype.slice.call(content.querySelectorAll('figure')).filter(isVisible).length;
    var standaloneImages = Array.prototype.slice.call(content.querySelectorAll('img:not(figure img)')).filter(isVisible).length;
    var mediaCount = figures + standaloneImages;
    var moduleSelector = [
      'table',
      '.hw-timeline',
      '.hw-featured-stat',
      '.hw-evidence-comparison',
      '.hw-three-part-summary'
    ].join(',');
    var moduleCount = Array.prototype.slice.call(content.querySelectorAll(moduleSelector)).filter(isVisible).length;
    var seconds = (words / 200) * 60 + mediaCount * 12 + moduleCount * 20;
    var minutes = Math.max(2, Math.ceil(seconds / 60));

    target.textContent = minutes + ' min read';
    target.dataset.wordCount = String(words);
    target.dataset.mediaCount = String(mediaCount);
    target.dataset.moduleCount = String(moduleCount);
    target.dataset.readingSeconds = String(Math.round(seconds));
  }

  function initArticle(root) {
    if (!root) return;

    var content = root.querySelector('[data-article-content]');
    var progress = root.querySelector('[data-reading-progress]');
    var toc = root.querySelector('[data-article-toc]');

    normalizeBody(content);
    placeArticleCallout(root, content);
    buildToc(content, toc);
    estimateReadingTime(root, content);
    initShareActions(root);

    // Content normalization and callout placement are deliberately idempotent and
    // run on every section refresh. Scroll/resize listeners are attached once.
    if (root.dataset.hwArticleReady === 'true') return;
    root.dataset.hwArticleReady = 'true';

    function updateProgress() {
      if (!progress || !content || !content.offsetHeight) return;
      var rect = content.getBoundingClientRect();
      var articleTop = window.scrollY + rect.top;
      var viewportMarker = window.scrollY + window.innerHeight * 0.25;
      var percent = ((viewportMarker - articleTop) / content.offsetHeight) * 100;
      progress.style.width = Math.max(0, Math.min(100, percent)) + '%';
    }

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-hw-article]')) initArticle(context);
    context.querySelectorAll('[data-hw-article]').forEach(initArticle);
  }

  // Fixture tests opt in to these internals before evaluating this file.
  if (window.__HW_ARTICLE_TEST__) {
    window.__HW_ARTICLE_TEST__.normalizeBody = normalizeBody;
    window.__HW_ARTICLE_TEST__.narrativeParagraphs = narrativeParagraphs;
    window.__HW_ARTICLE_TEST__.calloutTargetIndex = calloutTargetIndex;
    window.__HW_ARTICLE_TEST__.placeArticleCallout = placeArticleCallout;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  /** Console helper: find widest overflowing descendant inside .hw-article */
  window.hwArticleOverflowDiag = function () {
    var root = document.querySelector('.hw-article');
    if (!root) return { error: 'No .hw-article on page' };
    var vw = document.documentElement.clientWidth;
    var docW = document.documentElement.scrollWidth;
    var worst = { selector: '', width: 0, right: 0, overflow: docW - vw };
    root.querySelectorAll('*').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width <= worst.width) return;
      var sel = el.tagName.toLowerCase();
      if (el.id) sel += '#' + el.id;
      if (el.className && typeof el.className === 'string') {
        sel += '.' + el.className.trim().split(/\s+/).slice(0, 3).join('.');
      }
      worst = { selector: sel, width: Math.round(r.width), right: Math.round(r.right), overflow: docW - vw };
    });
    return { viewport: vw, scrollWidth: docW, horizontalOverflow: docW - vw, widest: worst };
  };

  /** Console helper: audit inline article-body images (Trend Lines chart diagnosis). */
  window.hwArticleContentImageDiag = function () {
    var content = document.querySelector('[data-article-content]');
    if (!content) return { error: 'No [data-article-content] on page' };
    var rows = Array.prototype.map.call(content.querySelectorAll('img'), function (img, index) {
      return {
        index: index,
        alt: img.getAttribute('alt') || '',
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || '',
        currentSrc: img.currentSrc || '',
        naturalWidth: img.naturalWidth,
        naturalHeight: img.naturalHeight,
        complete: img.complete,
        displayedWidth: Math.round(img.getBoundingClientRect().width),
        displayedHeight: Math.round(img.getBoundingClientRect().height),
        broken: img.complete && img.naturalWidth === 0
      };
    });
    return { imageCount: rows.length, images: rows };
  };
})();
